module.exports = __webpack_public_path__ + "img/diamonds4_2.96d72fd1.png";